import React from "react";
import { Route, Routes } from "react-router-dom";

import Login from "../views/common/login";
import Signup from "../views/common/signup";
import GetUserDetails from "../views/common/getUserDetails";
import ChangePassword from "../views/common/changePassword";
import ForgotPassword from "../views/common/login/forgetPassword/verifyEmail";
import ResetPassword from "../views/common/login/forgetPassword/resetPassword";
import ErrorPage from "../views/common/errorPage";

import WebLayout from "../website/component/layout/layout";
import Layout from "../component/layout/layout";
import AdminLayout from "../component/layout/adminLayout";
import SellerLayout from "../component/layout/sellerLayout";
import SmartLayout from "../component/layout/smartLayout";
import ProtectRoute from "../component/layout/protectRoute";

import websiteRoutes from "../website/router";
import adminRoutes from "./admin/routes";
import sellerRoutes from "./seller/routes";
import routes from "../admin/routes";
import AmazonConnection from "../views/seller/amazon";

export default function Router() {
  // Admin routes use SmartLayout - sellers see SellerLayout, admins see AdminLayout
  const adminRoute = adminRoutes.map(({ path, title, element }, index) => {
    return (
      <Route
        key={`admin-route-${path}-${index}`}
        path={`/${path}`}
        element={
          <SmartLayout>
            <ProtectRoute>{element}</ProtectRoute>
          </SmartLayout>
        }
      />
    );
  });

  const sellerRoute = sellerRoutes.map(({ path, title, element }, index) => {
    return (
      <Route
        key={`seller-route-${path}-${index}`}
        path={`/${path}`}
        element={
          <SellerLayout>
            <ProtectRoute>{element}</ProtectRoute>
          </SellerLayout>
        }
      />
    );
  });

  const webRoutes = websiteRoutes.map(({ path, element, children }, index) => {
    if (children) {
      // Handle nested routes
      return (
        <Route key={`web-route-${path}-${index}`} path={path} element={<WebLayout>{element}</WebLayout>}>
          {children.map(({ path: childPath, element: childElement }, childIndex) => (
            <Route key={`web-child-${childPath}-${childIndex}`} path={childPath} element={childElement} />
          ))}
        </Route>
      );
    }
    return <Route key={`web-route-${path}-${index}`} path={path} element={<WebLayout>{element}</WebLayout>} />;
  });

  const newAdminRoutes = routes.map(({ path, element }, index) => {
    return (
      <Route
        key={`new-admin-${path}-${index}`}
        path={`/${path}`}
        element={
          <SmartLayout>
            <ProtectRoute>{element}</ProtectRoute>
          </SmartLayout>
        }
      />
    );
  });

  return (
    <Routes>
      <Route key="login" path="/login" element={<Login />} />
      <Route key="signup" path="/signup" element={<Signup />} />
      <Route key="getUserDetails" path="/getUserDetails" element={<GetUserDetails />} />
      <Route
        key="forgotPassword"
        path="/login/forgetPassword/verifyEmail"
        element={<ForgotPassword />}
      />
      <Route
        key="resetPassword"
        path="/login/forgetPassword/ResetPassword"
        element={<ResetPassword />}
      />
      <Route
        key="changePassword"
        path="/changePassword"
        element={
          <Layout>
            <ProtectRoute>
              <ChangePassword />
            </ProtectRoute>
          </Layout>
        }
      />

      <Route key="amazonConnect" path="/amazon/connect" element={<AmazonConnection />} />

      {webRoutes}
      {adminRoute}
      {sellerRoute}
      {newAdminRoutes}

      <Route key="errorPage" path="*" element={<ErrorPage />} />
    </Routes>
  );
}
